import comp from "./LearningGoalsListView";
export default comp;
